module.exports = __webpack_public_path__ + "static/media/access-background.e0d0ac33.jpeg";